// GovWellRequestHeaders is duplicated on the BE
export enum GovWellRequestHeaders {
  Platform = 'X-Govwell-Platform',
  TimeZone = 'X-Govwell-Time-Zone',
}
